export default __webpack_public_path__ + "static/media/SuccessPage.59fe524a.png";